<template>
  <!-- Services Section Start -->
  <section  class="section-padding">
    <div class="container">
      <div class="section-header text-center">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">خدمات ما</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row">
        <!-- Services item -->
        <div v-for="(item,id) in AppItems" :key="id" class="col-md-6 col-lg-4 col-xs-12">
          <div class="services-item wow fadeInRight" data-wow-delay="0.3s">
            <div class="icon">
              <i :class="item.icon"></i>
            </div>
            <div class="services-content">
              <h3 class="text-center"><a :href="item.link" >{{ item.title }}</a></h3>
              <p class="text-muted text-center">{{item.sub}}</p>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Services Section End -->
</template>

<script>
import {services} from '../Data/servicesData'
export default {
  name: "OurServices",
  data() {
    return {
      AppItems:  services,

    }
  }
}
</script>

<style scoped>

</style>